// import phoneMask from "../Components/phoneMask";
import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask, round2Decimals } from "../Components/Items";
import numeroALetra from "../Components/numeroALetra";
import { formatQRTotal } from "../Components/RoundQRDecimals";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";
import { formatearDireccionEntrega } from "../Components/PdfComponents/formatearDireccionEntrega";
import { BloqueFirmasPdf } from "../Components/PdfComponents/BloqueFirmasPdf";
import facturaPdfV2 from "./PdfV2.0/facturaPdfV2";


moment.locale("es");

// Plantilla clásica de factura 
const facturaPdfClasico = (values) => {
  const empresa = values.respuestaFactura.empresa;

  const dataSat = values.respuestaFactura.dataSat;
  const dataExtra = values.respuestaFactura.data;
  const idKiosko = values.kioskoid;
  const direccionEntrega = values.respuestaFactura?.dataSat?.direccionEntrega || [];
  const mostrarOC = !empresa?.deshabilitarOCPdf;
  const mostrarFechaEntrega = !empresa?.deshabilitarFechaEntregaPdf;
  const { referencia: referenciaEntrega, direccion: direccionEntregaTexto } = formatearDireccionEntrega(
    direccionEntrega,
    { mostrarReferencia: !!empresa?.mostrarReferenciaEntregaPdf }
  );
  const numeroRemision = values?.remisionNumero;
  const serieRemision = values?.remisionSerie;
  const mostrarDescUnidad = empresa?.imprimirDesUnidad ;
  const decimalesTipoCambioPdf = Number.isFinite(Number(empresa?.decimalesTipoCambioPdf)) ? Number(empresa.decimalesTipoCambioPdf) : 4;
  const decimalesPrecioUnitarioPdf = Number.isFinite(Number(empresa?.decimalesPrecioUnitarioPdf)) ? Number(empresa.decimalesPrecioUnitarioPdf) : 2;
  const decimalesCantidadPdf = Number.isFinite(Number(empresa?.decimalesCantidadPdf)) ? Number(empresa.decimalesCantidadPdf) : 2;
  const formatCantidad = (val) => {
    const num = Number(val);
    if (!Number.isFinite(num)) return val;
    return num.toLocaleString('es-MX', { minimumFractionDigits: decimalesCantidadPdf, maximumFractionDigits: decimalesCantidadPdf });
  };
  let agregarEquipoMedico = []
  const proyecto = values.respuestaFactura?.dataSat?.proyecto || []; 

  const quitarImpuestosRemisiones = empresa?.quitarImpuestosRemisiones || false;
  const quitarImpuestosFacturas = empresa?.quitarImpuestosFacturas || false;
  const ocultarColumnaIVA = empresa?.ocultarColumnaIVA || false;
  const cantidadJuntoPrecioUnitario = empresa?.cantidadJuntoPrecioUnitario || false;
  // Importe de cada renglón con sus impuestos; "No Desglosar Imp. Facturas" ya los incluye
  const importeConImpuestos = empresa?.importeConImpuestos === true && !quitarImpuestosFacturas;
  const tituloImporte = importeConImpuestos ? "Importe con Impuestos" : "Importe";
  // Columna con el P/U ya descontado, a la derecha del P/U
  const precioUnitarioConDescuento = empresa?.precioUnitarioConDescuento === true;
  const widthPUConDescuento = 9;
  let agregarImpDesc = 0;

  // Ocultar clave y clave SAT
  const mostrarClaveSAT = !empresa?.deshabilitarClaveSATCot; 
  const mostrarClave = !empresa?.deshabilitarClaveCot; 

  const widthClaveSAT = quitarImpuestosRemisiones ? 8 : 9;
  const widthClave = quitarImpuestosRemisiones ? 9 : 12;
  const widthIEPS = 8;
  const widthIVA = 9;

  let widthExtraDescripcion = 0;
  //Agregar los anchos que no se muestran a la descripción
  if(!mostrarClaveSAT) widthExtraDescripcion += widthClaveSAT;
  if(!mostrarClave) widthExtraDescripcion += widthClave;
  if (!quitarImpuestosRemisiones && !quitarImpuestosFacturas && !empresa.imprimirIEPS) {
      widthExtraDescripcion += widthIEPS;
  }
  if (!quitarImpuestosRemisiones && ocultarColumnaIVA && !quitarImpuestosFacturas) {
      widthExtraDescripcion += widthIVA;
  }

  const widthExtraCantidad = Math.round(widthExtraDescripcion * 0.05 * 10) / 10;
  const widthExtraUnidad = Math.round(widthExtraDescripcion * 0.15 * 10) / 10;
  const widthExtraClave = mostrarClave ? Math.round(widthExtraDescripcion * 0.15 * 10) / 10 : 0;
  const widthExtraDescripcionFinal = Math.round((widthExtraDescripcion - widthExtraCantidad - widthExtraUnidad - widthExtraClave) * 10) / 10;
  //El flag de remisiones recorta 1% y 3% a Clave SAT y Clave; en la tabla sin
  //impuestos se devuelven a Descripción para que los anchos sumen 100%
  const widthDevueltoClaves = (9 - widthClaveSAT) + (12 - widthClave);

  if ((values.doctor || values.paciente) && empresa?._id?.toString() !== "6794158fb43c29469460b824") {
    agregarEquipoMedico.push(
      {
        style: "tableExample",
        table: {
          widths: ["50%", "50%"],
          layout: {
            defaultBorder: false,
          },

          body: [
            [
              {
                table: {
                  widths: ["40%", "60%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                    [
                      { text: "Nombre del doctor :", style: "subheader" },
                      { text: values?.doctor?.nombre ? values?.doctor?.nombre : '', style: "textoChico" },
                    ],
                  ],
                },
                layout: "noBorders",
              },

              {
                table: {
                  widths: ["40%", "60%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                    [
                      { text: "Nombre del paciente :", style: "subheader" },
                      { text: values?.paciente?.nombre ? values?.paciente?.nombre : '', style: "textoChico" },
                    ],
                    [
                      { text: "Cirugia :", style: "subheader" },
                      { text: values?.cirugia?.nombre ? (values.cirugia.nombre) : (values?.paciente?.cirugia ? values?.paciente?.cirugia : ''), style: "textoChico" },
                    ],
                  ],
                },
                layout: "noBorders",
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        },
      },
    )
  }

  let cartaPorte

  let complementoComercioExterior


  if (dataSat?.Complemento?.Any.find(item => item['cartaporte31:CartaPorte'])) {
    cartaPorte = dataSat.Complemento.Any.find(item => item['cartaporte31:CartaPorte'])['cartaporte31:CartaPorte']
  }

  if (dataSat?.Complemento?.Any.find(item => item['cartaporte30:CartaPorte'])) {
    cartaPorte = dataSat.Complemento.Any.find(item => item['cartaporte30:CartaPorte'])['cartaporte30:CartaPorte']
  }

  if (dataSat?.Complemento?.Any.find(item => item['cce11:ComercioExterior'])) {
    complementoComercioExterior = dataSat.Complemento.Any.find(item => item['cce11:ComercioExterior'])['cce11:ComercioExterior']
  }

  if (dataSat?.Complemento?.Any.find(item => item['cce20:ComercioExterior'])) {
    complementoComercioExterior = dataSat.Complemento.Any.find(item => item['cce20:ComercioExterior'])['cce20:ComercioExterior']
  }

  const esDataUrlValida = (s) =>
    typeof s === "string" &&
    /^data:(image|application)\/[a-zA-Z0-9.+-]+;base64,/.test(s);

  const conceptos = dataSat.Conceptos.flatMap((valueConcepto, index) => {
    let iva = 0;
    let ieps = 0;
    let agregarImpConcepto = 0;
    const relacionDescuento = Number(valueConcepto.Descuento || 0) / Number(valueConcepto.Importe || 1);
    // Suma de impuestos (usa forEach; map no se aprovecha aquí)
    valueConcepto.Impuestos?.Traslados?.forEach((valueImpuesto) => {
      if (valueImpuesto.Impuesto === "002" && valueImpuesto.Importe) {
        iva += valueImpuesto.Importe;
        agregarImpConcepto += valueImpuesto.Importe / (1 - relacionDescuento) - valueImpuesto.Importe;
      }
      if (valueImpuesto.Impuesto === "003" && valueImpuesto.Importe) {
        ieps += valueImpuesto.Importe;
        agregarImpConcepto += valueImpuesto.Importe / (1 - relacionDescuento) - valueImpuesto.Importe;
      }
    });
    agregarImpDesc += agregarImpConcepto;
    // P/U menos el descuento del renglón, en la misma base que la columna P/U
    const precioUnitarioNeto = Number(valueConcepto.ValorUnitario) - Number(valueConcepto.Descuento || 0) / Number(valueConcepto.Cantidad || 1);
    const precioUnitarioNetoConImpuestos = (Number(valueConcepto.Importe) - Number(valueConcepto.Descuento || 0) + iva + ieps) / Number(valueConcepto.Cantidad || 1);
    const celdaPrecioUnitarioNeto = (valor) => ({
      text: dineroDisabledMask(valor, decimalesPrecioUnitarioPdf),
      style: "textoTablaChico",
      alignment: "right",
    });

    // --- Fila base (tu código, intacto) ---
    const celdaCantidad = {
      style: "textoTablaChico",
      text: formatCantidad(valueConcepto.Cantidad),
      alignment: "right",
    };
    const tabla = dataSat.Receptor.impresionEspecial
      ? [
        { style: "textoTablaChico", text: index + 1, alignment: "center" },
        ...(cantidadJuntoPrecioUnitario ? [] : [celdaCantidad]),
        {
          text: (mostrarDescUnidad  &&  valueConcepto.descUnidad) ? valueConcepto.descUnidad : valueConcepto.ClaveUnidad, //clave unidad
          style: "textoTablaChico",
          alignment: "center",
        },
        {
          text: valueConcepto.ClaveProdServ,
          style: "textoTablaChico",
          alignment: "center",
        },
        {
          ...(() => {
            const textoDescSinObs =
              valueConcepto.Descripcion +
              (valueConcepto?.CuentaPredial?.[0]?.Numero ? ("\nPredial: " + valueConcepto?.CuentaPredial?.[0]?.Numero) : "") +
              (valueConcepto.Marca ? "\nMarca: " + valueConcepto.Marca : "") +
              (valueConcepto.CodigoBarras ? "\n" + valueConcepto.CodigoBarras : "");
            const textoDesc = textoDescSinObs + (valueConcepto.Observaciones ? "\n" + valueConcepto.Observaciones : "");
            const tieneLotes = Array.isArray(valueConcepto.Lotes) && valueConcepto.Lotes.length > 0;
            const tieneComponentesKit = Array.isArray(valueConcepto.ComponentesKit) && valueConcepto.ComponentesKit.length > 0;
            if (tieneLotes || tieneComponentesKit || valueConcepto.DescripcionLarga) {
              // Descripcion larga del producto (solo PDF): debajo del concepto y antes de las observaciones
              const stackExtra = valueConcepto.DescripcionLarga
                ? [
                  { text: textoDescSinObs, style: "textoTablaChico" },
                  { text: valueConcepto.DescripcionLarga, fontSize: 5, color: "#555", margin: [0, 1, 0, 0] },
                  ...(valueConcepto.Observaciones ? [{ text: valueConcepto.Observaciones, style: "textoTablaChico" }] : []),
                ]
                : [{ text: textoDesc, style: "textoTablaChico" }];
              if (tieneLotes) {
                stackExtra.push({ text: valueConcepto.Lotes.map(lote => `Cant: ${lote?.cantidadRequerida ?? "-"} - Lote: ${lote?.numero ?? lote?.lote ?? "-"} - Cad: ${lote?.caducidad && moment(lote.caducidad).isSameOrAfter(moment(dataSat.Fecha), 'day') ? moment(lote.caducidad).format("DD/MM/YYYY") : "-"}`).join("\n"), fontSize: 5, color: "#555", margin: [0, 2, 0, 0] });
              }
              if (tieneComponentesKit) {
                stackExtra.push({ text: "Incluye: " + valueConcepto.ComponentesKit.map(c => `${c.descripcion} (x${c.cantidad})`).join(", "), fontSize: 5, color: "#555", margin: [0, 2, 0, 0] });
              }
              return {
                stack: stackExtra,
                alignment: "left",
              };
            }
            return { text: textoDesc, style: "textoTablaChico", alignment: "left" };
          })(),
        },
        ...(cantidadJuntoPrecioUnitario ? [celdaCantidad] : []),
        {
          stack: [
            {
              text: dineroDisabledMask(valueConcepto.ValorUnitario, decimalesPrecioUnitarioPdf),
              style: "textoTablaChico",
              alignment: "right",
            },

            ...(
              !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
                ? [{
                  columns: [
                    {
                      text:
                        round2Decimals(
                          (Number(valueConcepto.Descuento) * 100) /
                          (Number(valueConcepto.Cantidad || 1) *
                            Number(valueConcepto.ValorUnitario || 1))
                        ) + "%",
                      width: "*",
                      alignment: "left",
                      style: "descuentoPartida",
                      noWrap: true,
                    },
                    {
                      text: dineroDisabledMask(round2Decimals(
                        Number(valueConcepto.Descuento) /
                        Number(valueConcepto.Cantidad || 1)
                      )),
                      width: "auto",
                      style: "descuentoPartida",
                    }
                  ],
                  columnGap: 8,
                  margin: [0, 2, 0, 0]
                }]
                : []
            )
          ]
        },
        ...(precioUnitarioConDescuento ? [celdaPrecioUnitarioNeto(precioUnitarioNeto)] : []),
        ...(ocultarColumnaIVA ? [] : [{
          text: dineroDisabledMask(iva),
          style: "textoTablaChico",
          alignment: "right",
        }]),
        {
          text: dineroDisabledMask(ieps),
          style: "textoTablaChico",
          alignment: "right",
        },
        {
          stack: [
            {
              text: dineroDisabledMask(valueConcepto.Importe),
              style: "textoTablaChico",
              alignment: "right",
            },
            ...(
              !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
                ? [{
                  text: "- " + dineroDisabledMask(Number(valueConcepto.Descuento)),
                  style: "descuentoPartida",
                  alignment: "right",
                  margin: [0, 2, 0, 0],
                }]
                : []
            )
          ]
        }
      ]
      : [
        { style: "textoTablaChico", text: index + 1, alignment: "center" },
        ...(cantidadJuntoPrecioUnitario ? [] : [celdaCantidad]),
        {
          text: (mostrarDescUnidad  &&  valueConcepto.descUnidad) ? valueConcepto.descUnidad : valueConcepto.ClaveUnidad, //clave unidad
          style: "textoTablaChico",
          alignment: "center",
        },
        ...(mostrarClaveSAT ? [{
          text: valueConcepto.ClaveProdServ,
          style: "textoTablaChico",
          alignment: "center",
        }] : []),
        ...(mostrarClave ? [{
          text: valueConcepto.NoIdentificacion,
          style: "textoTablaChico",
          alignment: "center",
        }] : []),
        {
          ...(() => {
            const textoDescSinObs =
              valueConcepto.Descripcion +
              (valueConcepto?.CuentaPredial?.[0]?.Numero ? ("\nPredial: " + valueConcepto?.CuentaPredial?.[0]?.Numero) : "") +
              (valueConcepto.Marca ? "\nMarca: " + valueConcepto.Marca : "") +
              (valueConcepto.CodigoBarras ? "\n" + valueConcepto.CodigoBarras : "");
            const textoDesc = textoDescSinObs + (valueConcepto.Observaciones ? "\n" + valueConcepto.Observaciones : "");
            const tieneLotes = Array.isArray(valueConcepto.Lotes) && valueConcepto.Lotes.length > 0;
            const tieneComponentesKit = Array.isArray(valueConcepto.ComponentesKit) && valueConcepto.ComponentesKit.length > 0;
            if (tieneLotes || tieneComponentesKit || valueConcepto.DescripcionLarga) {
              // Descripcion larga del producto (solo PDF): debajo del concepto y antes de las observaciones
              const stackExtra = valueConcepto.DescripcionLarga
                ? [
                  { text: textoDescSinObs, style: "textoTablaChico" },
                  { text: valueConcepto.DescripcionLarga, fontSize: 5, color: "#555", margin: [0, 1, 0, 0] },
                  ...(valueConcepto.Observaciones ? [{ text: valueConcepto.Observaciones, style: "textoTablaChico" }] : []),
                ]
                : [{ text: textoDesc, style: "textoTablaChico" }];
              if (tieneLotes) {
                stackExtra.push({ text: valueConcepto.Lotes.map(lote => `Cant: ${lote?.cantidadRequerida ?? "-"} - Lote: ${lote?.numero ?? lote?.lote ?? "-"} - Cad: ${lote?.caducidad && moment(lote.caducidad).isSameOrAfter(moment(dataSat.Fecha), 'day') ? moment(lote.caducidad).format("DD/MM/YYYY") : "-"}`).join("\n"), fontSize: 5, color: "#555", margin: [0, 2, 0, 0] });
              }
              if (tieneComponentesKit) {
                stackExtra.push({ text: "Incluye: " + valueConcepto.ComponentesKit.map(c => `${c.descripcion} (x${c.cantidad})`).join(", "), fontSize: 5, color: "#555", margin: [0, 2, 0, 0] });
              }
              return {
                stack: stackExtra,
                alignment: "left",
              };
            }
            return { text: textoDesc, style: "textoTablaChico", alignment: "left" };
          })(),
        },
        //Precio unitario y despuesto individual
        ...(cantidadJuntoPrecioUnitario ? [celdaCantidad] : []),
        {
          stack: [
            {
              text: dineroDisabledMask(
                quitarImpuestosFacturas
                  ? (Number(valueConcepto.Importe) + iva + ieps + agregarImpConcepto) / Number(valueConcepto.Cantidad || 1)
                  : valueConcepto.ValorUnitario,
                decimalesPrecioUnitarioPdf
              ),
              style: "textoTablaChico",
              alignment: "right",
            },

            ...(
              !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
                ? [{
                  columns: [
                    {
                      text:
                        round2Decimals(
                          (Number(valueConcepto.Descuento) * 100) /
                          (Number(valueConcepto.Cantidad || 1) *
                            Number(valueConcepto.ValorUnitario || 1))
                        ) + "%",
                      width: "*",
                      alignment: "left",
                      style: "descuentoPartida",
                      noWrap: true,
                    },
                    {
                      text: dineroDisabledMask(round2Decimals(
                        Number(valueConcepto.Descuento) /
                        Number(valueConcepto.Cantidad || 1)
                      )),
                      width: "auto",
                      style: "descuentoPartida",
                    }
                  ],
                  columnGap: 8,
                  margin: [0, 2, 0, 0]
                }]
                : []
            )
          ]
        },
        ...(precioUnitarioConDescuento ? [celdaPrecioUnitarioNeto(quitarImpuestosFacturas ? precioUnitarioNetoConImpuestos : precioUnitarioNeto)] : []),
        ...(quitarImpuestosFacturas ? [] : [
          ...(ocultarColumnaIVA ? [] : [{
            text: dineroDisabledMask(iva),
            style: "textoTablaChico",
            alignment: "right",
          }]),

          ...(empresa.imprimirIEPS
            ? [
              {
                text: dineroDisabledMask(ieps),
                style: "textoTablaChico",
                alignment: "right",
              },
            ]
            : []),
        ]),
        {
          stack: [
            {
              text: dineroDisabledMask(
                quitarImpuestosFacturas
                  ? Number(valueConcepto.Importe) + iva + ieps + agregarImpConcepto
                  : importeConImpuestos
                    ? Number(valueConcepto.Importe) - Number(valueConcepto.Descuento || 0) + iva + ieps
                    : valueConcepto.Importe
              ),
              style: "textoTablaChico",
              alignment: "right",
            },
            ...(
              !importeConImpuestos && !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
                ? [{
                  text: "- " + dineroDisabledMask(Number(valueConcepto.Descuento)),
                  style: "descuentoPartida",
                  alignment: "right",
                  margin: [0, 2, 0, 0],
                }]
                : []
            )
          ]
        }
      ];

    // --- Imágenes: vienen en base64, solo validar que lo sean ---
    // Acepta: ["data:..."] o [{ base64Completa: "data:..." }]
    const imagenesEntrada = Array.isArray(valueConcepto.imagenes)
      ? valueConcepto.imagenes
      : [];

    const imagenesBase64 = imagenesEntrada
      .map((img) => (typeof img === "string" ? img : img?.base64Completa))
      .filter(esDataUrlValida);

    if (imagenesBase64.length === 0) {
      // No hay imágenes válidas -> solo la fila base
      return [tabla];
    }

    // Hay imágenes -> agregamos fila extra que abarca todas las columnas
    let totalColsNormal = 6; //linea, cantidad, unidad, descripción, P/U e importe
    if (mostrarClaveSAT) totalColsNormal++;
    if (mostrarClave) totalColsNormal++;
    if (!quitarImpuestosFacturas) {
      if (!ocultarColumnaIVA) totalColsNormal++;
      if (empresa.imprimirIEPS) totalColsNormal++;
    }
    if (precioUnitarioConDescuento) totalColsNormal++;
    const totalCols = dataSat.Receptor.impresionEspecial ? (ocultarColumnaIVA ? 8 : 9) + (precioUnitarioConDescuento ? 1 : 0) : totalColsNormal;

    const filaImagenes = new Array(totalCols).fill({});
    filaImagenes[0] = {
      colSpan: totalCols,
      alignment: "center",
      margin: [0, 2, 0, 6],
      border: [true, false, true, true],
      columns: imagenesBase64.map((img) => ({
        image: img,      // pdfMake acepta data URL aquí
        fit: [120, 120], // ajusta tamaño a tu gusto
        margin: [5, 5, 5, 5],
      })),
    };

    // Devolvemos la fila base + la fila de imágenes
    return [tabla, filaImagenes];
  });

  const nuevoArrayImpFL = Array.isArray(dataSat.Impuestos.Traslados) ?
    [...dataSat.Impuestos.Traslados, ...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:TrasladosLocales"] || [])]
    :
    [...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:TrasladosLocales"] || [])]


  // Definir orden personalizado
  const ordenImpuestos = ["IVA 0%", "IVA 16%", "IEPS 6%", "IEPS 7%", "IEPS 9%"];

  // Ordenar el array antes del map
  const nuevoArrayImpFLOdenado = [...nuevoArrayImpFL].sort((a, b) => {
    const nombreA = a.Impuesto === "002"
      ? `IVA ${round2Decimals(a.TasaOCuota * 100)}%`
      : a.Impuesto === "003"
        ? `IEPS ${round2Decimals(a.TasaOCuota * 100)}%`
        : a["@ImpLocTrasladado"];
    const nombreB = b.Impuesto === "002"
      ? `IVA ${round2Decimals(b.TasaOCuota * 100)}%`
      : b.Impuesto === "003"
        ? `IEPS ${round2Decimals(b.TasaOCuota * 100)}%`
        : b["@ImpLocTrasladado"];

    return ordenImpuestos.indexOf(nombreA) - ordenImpuestos.indexOf(nombreB);
  });

  const impuestosTotales = nuevoArrayImpFLOdenado.map(
    (valueImpuesto, indexImpuesto) => {
      let nombre = "";
      if (valueImpuesto.Impuesto === "002") {
        nombre = "IVA";
      } else if (valueImpuesto.Impuesto === "003") {
        nombre = "IEPS";
      } else {
        nombre = valueImpuesto["@ImpLocTrasladado"]
      }

      if (valueImpuesto.TipoFactor === "Tasa") {
        nombre = nombre + " " + round2Decimals(valueImpuesto.TasaOCuota * 100) + "%";
      } else if (valueImpuesto.TipoFactor === "Cuota") {
        nombre = nombre + " $" + round2Decimals(valueImpuesto.TasaOCuota);
      }

      let border = indexImpuesto + 1 === nuevoArrayImpFLOdenado.length;
      return [
        {
          border: [true, false, false, border],
          text: nombre,
          style: "subheader",
        },
        {
          border: [false, false, true, border],
          text: dineroDisabledMask(valueImpuesto.Importe || valueImpuesto["@Importe"] || 0),
          style: "textoChico",
          alignment: "right",
        },
      ];
    }
  );

  const nuevoArrayRetFL = Array.isArray(dataSat.Impuestos.Retenciones) ?
    [...dataSat.Impuestos.Retenciones, ...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:RetencionesLocales"] || [])]
    :
    [...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:RetencionesLocales"] || [])]

  const retencionesTotales = nuevoArrayRetFL.map(
    (valueRetencion, indexRetencion) => {
      let nombre = "Retención ";
      if (valueRetencion.Impuesto === "001") {
        nombre = nombre + "ISR";
      } else if (valueRetencion.Impuesto === "002") {
        nombre = nombre + "IVA";
      } else {
        nombre = valueRetencion["@ImpLocRetenido"]
      }

      let border = indexRetencion + 1 === nuevoArrayRetFL.length;
      return [
        {
          border: [true, false, false, border],
          text: nombre,
          style: "subheader",
        },
        {
          border: [false, false, true, border],
          text: dineroDisabledMask(valueRetencion.Importe || valueRetencion["@Importe"]),
          style: "textoChico",
          alignment: "right",
        },
      ];
    }
  )

  const totalImpFL = dataSat.Impuestos.TotalImpuestosTrasladados + (dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["@TotaldeTraslados"] || 0) || 0
  const totalRetFL = dataSat.Impuestos.TotalImpuestosRetenidos + (dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["@TotaldeRetenciones"] || 0) || 0

  let cancelado = {}
  if (values.estado === 0) {
    cancelado = { watermark: { text: 'CANCELADO', color: 'GRAY', opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 110 } }
  }
  else if (values.esPreview) {
    cancelado = { watermark: { text: 'VISTA PREVIA', color: '#1677ff', opacity: 0.15, bold: true, italics: false, angle: -50, fontSize: 90 } }
  }
  let observaciones = {}
  if (values.imprimirObservaciones && values.observaciones) {
    observaciones = {
      table: {
        widths: ['*'],
        body: [
          [
            {
              border: [true, true, true, false],
              text: "Observaciones:",
              margin: [0, 0, 0, 5],
              style: "header",
            },
          ],
          [
            {
              border: [true, false, true, true],
              text: values.observaciones,
              margin: [0, 0, 0, 5],
              style: "textoChico",
            },
          ],
        ],
      },
      layout: {
        defaultBorder: false,
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 1 : 1;
        },
        vLineWidth: function (i, node) {
          return i === 0 || i === node.table.widths.length ? 1 : 1;
        },
        hLineColor: function (i, node) {
          return "#adaaaa";
        },
        vLineColor: function (i, node) {
          return "#adaaaa";
        },
        hLineStyle: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return null;
          }
          return { dash: { length: 2, space: 1 } };
        },
        vLineStyle: function (i, node) {
          if (i === 0 || i === node.table.widths.length) {
            return null;
          }
          return { dash: { length: 2 } };
        },
      },
    };
  }

  const mostrarBancos = !empresa?.deshabilitarBancoFactura && !dataSat?.deshabilitarBanco;

  const filasBanco1 = [
    [
      {
        border: [true, true, false, false],
        text: "Banco:",
        style: "subheader",
      },
      {
        border: [false, true, true, false],
        text: empresa.banco ? empresa.banco : "",
        style: "textoChico",
      },
    ],
    ...(empresa.swiftCode
      ? [
        [
          {
            border: [true, false, false, false],
            text: "Swift Code:",
            style: "subheader",
          },
          {
            border: [false, false, true, false],
            text: empresa.swiftCode ? empresa.swiftCode : "",
            style: "textoChico",
          },
        ],
      ]
      : []),
    ...(empresa.abaCode
      ? [
        [
          {
            border: [true, false, false, false],
            text: "ABA Code:",
            style: "subheader",
          },
          {
            border: [false, false, true, false],
            text: empresa.abaCode ? empresa.abaCode : "",
            style: "textoChico",
          },
        ],
      ]
      : []),
    [
      {
        border: [true, false, false, false],
        text: "Cuenta:",
        style: "subheader",
      },
      {
        border: [false, false, true, false],
        text: empresa.cuentaBanco ? empresa.cuentaBanco : "",
        style: "textoChico",
      },
    ],
    [
      {
        border: [true, false, false, true],
        text: "Cuenta CLABE:",
        style: "subheader",
      },
      {
        border: [false, false, true, true],
        text: empresa.cuentaClabe ? empresa.cuentaClabe : "",
        style: "textoChico",
      },
    ],
  ];

  const filasBanco2 = empresa.banco2 && empresa.banco2 !== "" ?
    [[
      {
        border: [true, true, false, false],
        text: "Banco:",
        style: "subheader",
      },
      {
        border: [false, true, true, false],
        text: empresa.banco2 ? empresa.banco2 : "",
        style: "textoChico",
      },
    ],
    ...(empresa.swiftCode2 ? [[
      {
        border: [true, false, false, false],
        text: "Swift Code:",
        style: "subheader",
      },
      {
        border: [false, false, true, false],
        text: empresa.swiftCode2 ? empresa.swiftCode2 : "",
        style: "textoChico",
      },
    ]] : []),
    ...(empresa.abaCode2 ? [[
      {
        border: [true, false, false, false],
        text: "ABA Code:",
        style: "subheader",
      },
      {
        border: [false, false, true, false],
        text: empresa.abaCode2 ? empresa.abaCode2 : "",
        style: "textoChico",
      },
    ]] : []),
    [
      {
        border: [true, false, false, false],
        text: "Cuenta:",
        style: "subheader",
      },
      {
        border: [false, false, true, false],
        text: empresa.cuentaBanco2 ? empresa.cuentaBanco2 : "",
        style: "textoChico",
      },
    ],
    [
      {
        border: [true, false, false, true],
        text: "Cuenta CLABE:",
        style: "subheader",
      },
      {
        border: [false, false, true, true],
        text: empresa.cuentaClabe2 ? empresa.cuentaClabe2 : "",
        style: "textoChico",
      },
    ]] : [];


  //Datos carta porte

  let ubicaciones = []

  if (cartaPorte?.Ubicaciones) {
    for (const ubicacion of cartaPorte.Ubicaciones) {
      ubicaciones.push(
        [
          {
            style: 'textoTablaChico',
            text: ubicacion.TipoUbicacion + ' - ' + ubicacion.IDUbicacion,
            alignment: 'center'
          },
          {
            style: 'textoTablaChico',
            text: ubicacion.RFCRemitenteDestinatario,
            alignment: 'center'
          },
          {
            style: 'textoTablaChico',
            text: ubicacion.NombreRemitenteDestinatario,
            alignment: 'lefth'
          },
          {
            text: 'MXN',
            style: 'textoTablaChico',
            alignment: 'center'
          },
          { text: '-', style: 'textoTablaChico', alignment: 'center' },
          { text: ubicacion.FechaHoraSalidaLlegada, style: 'textoTablaChico', alignment: 'center' },
        ],
        [
          { style: 'textoTablaChico', text: 'Domicilio:', alignment: 'lefth' },
          { style: 'textoTablaChico', text: (ubicacion.Domicilio.Calle ? ubicacion.Domicilio.Calle : '') + (ubicacion.Domicilio.NumeroExterior ? (' #' + ubicacion.Domicilio.NumeroExterior) : '') + (ubicacion.Domicilio.NumeroInterior ? (' - ' + ubicacion.Domicilio.NumeroInterior) : '') + ' Col: ' + ubicacion.Domicilio.ColoniaNombre + ' CP: ' + ubicacion.Domicilio.CodigoPostal + (ubicacion.Domicilio.Referencia ? (' Referencia: ' + ubicacion.Domicilio.Referencia) : '') + ' - ' + (ubicacion.Domicilio.MunicipioNombre ? ubicacion.Domicilio.MunicipioNombre : '') + ' ' + ubicacion.Domicilio.Estado + ' ' + ubicacion.Domicilio.Pais, alignment: 'lefth', colSpan: 5 },
          {},
          {},
          {},
          {},
        ]
      )
    }
  }


  let figuras = []

  if (cartaPorte?.FiguraTransporte) {
    for (const figura of cartaPorte.FiguraTransporte) {
      let tipoFiguraTexto

      if (figura.TipoFigura === '01') {
        tipoFiguraTexto = "Operador"
      } else if (figura.TipoFigura === '02') {
        tipoFiguraTexto = "Propietario"
      } else if (figura.TipoFigura === '03') {
        tipoFiguraTexto = "Arrendador"
      } else if (figura.TipoFigura === '04') {
        tipoFiguraTexto = "Notificado"
      }

      const filaDomicilioFigura = figura?.Domicilio && Object.keys(figura.Domicilio).length > 0
        ? [
          [
            { style: 'textoTablaChico', text: 'Domicilio:', alignment: 'left' },
            {
              style: 'textoTablaChico',
              text:
                (figura.Domicilio.Calle ? figura.Domicilio.Calle : '') +
                (figura.Domicilio.NumeroExterior ? ` #${figura.Domicilio.NumeroExterior}` : '') +
                (figura.Domicilio.NumeroInterior ? ` - ${figura.Domicilio.NumeroInterior}` : '') +
                (figura.Domicilio.ColoniaNombre ? ` Col: ${figura.Domicilio.ColoniaNombre}` : '') +
                (figura.Domicilio.CodigoPostal ? ` CP: ${figura.Domicilio.CodigoPostal}` : '') +
                (figura.Domicilio.Referencia ? ` Referencia: ${figura.Domicilio.Referencia}` : '') +
                (figura.Domicilio.MunicipioNombre ? ` - ${figura.Domicilio.MunicipioNombre}` : '') +
                (figura.Domicilio.Estado ? ` ${figura.Domicilio.Estado}` : '') +
                (figura.Domicilio.Pais ? ` ${figura.Domicilio.Pais}` : ''),
              alignment: 'left',
              colSpan: 5
            },
            {},
            {},
            {},
            {}
          ]
        ]
        : [];

      figuras.push(
        [
          {
            style: 'textoTablaChico',
            text: figura.TipoFigura + ' - ' + tipoFiguraTexto,
            alignment: 'center'
          },
          {
            style: 'textoTablaChico',
            text: figura.RFCFigura,
            alignment: 'center'
          },
          {
            style: 'textoTablaChico',
            text: figura.NombreFigura,
            alignment: 'lefth'
          },
          {
            text: figura.NumLicencia,
            style: 'textoTablaChico',
            alignment: 'center'
          },
          { text: figura.ResidenciaFiscalFigura ? figura.ResidenciaFiscalFigura : '-', style: 'textoTablaChico', alignment: 'center' },
          { text: figura.NumRegIdTribFigura ? figura.NumRegIdTribFigura : '-', style: 'textoTablaChico', alignment: 'center' },
        ],
        ...filaDomicilioFigura
      )
    }
  }


  let mercancias = []

  if (cartaPorte?.Mercancias?.Mercancia) {


    for (const mercancia of cartaPorte.Mercancias.Mercancia) {

      let agregarFinalMercancias = []
      let cantidadTotal = 0

      if (mercancia.CantidadTransporta) {
        for (const cantidad of mercancia.CantidadTransporta) {

          cantidadTotal += cantidad.Cantidad

          const ubicacionOrigen = cartaPorte?.Ubicaciones.find(valueUbi => valueUbi.IDUbicacion === cantidad.IDOrigen)
          const ubicacionDestino = cartaPorte?.Ubicaciones.find(valueUbi => valueUbi.IDUbicacion === cantidad.IDDestino)


          agregarFinalMercancias.push(
            [
              { style: 'textoTablaChico', text: cantidad.Cantidad, alignment: 'right' },
              { style: 'textoTablaChico', text: 'Origen: ' + ubicacionOrigen.IDUbicacion + ' - ' + (ubicacionOrigen.Domicilio.Calle ? ubicacionOrigen.Domicilio.Calle : '') + (ubicacionOrigen.Domicilio.NumeroExterior ? (' #' + ubicacionOrigen.Domicilio.NumeroExterior) : '') + (ubicacionOrigen.Domicilio.NumeroInterior ? (' - ' + ubicacionOrigen.Domicilio.NumeroInterior) : '') + ' Col: ' + ubicacionOrigen.Domicilio.ColoniaNombre + ' CP: ' + ubicacionOrigen.Domicilio.CodigoPostal + (ubicacionOrigen.Domicilio.Referencia ? (' Referencia: ' + ubicacionOrigen.Domicilio.Referencia) : '') + ' - ' + (ubicacionOrigen.Domicilio.MunicipioNombre ? ubicacionOrigen.Domicilio.MunicipioNombre : '') + ' ' + ubicacionOrigen.Domicilio.Estado + ' ' + ubicacionOrigen.Domicilio.Pais, alignment: 'lefth', colSpan: 3 },
              {},
              {},
              { style: 'textoTablaChico', text: 'Destino: ' + ubicacionDestino.IDUbicacion + ' - ' + (ubicacionDestino.Domicilio.Calle ? ubicacionDestino.Domicilio.Calle : '') + (ubicacionDestino.Domicilio.NumeroExterior ? (' #' + ubicacionDestino.Domicilio.NumeroExterior) : '') + (ubicacionDestino.Domicilio.NumeroInterior ? (' - ' + ubicacionDestino.Domicilio.NumeroInterior) : '') + ' Col: ' + ubicacionDestino.Domicilio.ColoniaNombre + ' CP: ' + ubicacionDestino.Domicilio.CodigoPostal + (ubicacionDestino.Domicilio.Referencia ? (' Referencia: ' + ubicacionDestino.Domicilio.Referencia) : '') + ' - ' + (ubicacionDestino.Domicilio.MunicipioNombre ? ubicacionDestino.Domicilio.MunicipioNombre : '') + ' ' + ubicacionDestino.Domicilio.Estado + ' ' + ubicacionDestino.Domicilio.Pais, alignment: 'lefth', colSpan: 4 },
              {},
              {},
              {},
            ]
          )

        }
      }

      mercancias.push(
        [
          { style: 'textoTablaChico', text: cantidadTotal, alignment: 'right' },
          {
            text: mercancia.Unidad,
            style: 'textoTablaChico',
            alignment: 'center'
          },
          {
            text: mercancia.BienesTransp + ' - ' + mercancia.Descripcion,
            style: 'textoTablaChico',
            alignment: 'center'
          },
          {
            text: mercancia.CveMaterialPeligroso ? mercancia.CveMaterialPeligroso : 'No',
            style: 'textoTablaChico',
            alignment: 'left'
          },
          {
            text: mercancia.Embalaje ? (mercancia.Embalaje + ' - ' + mercancia.DescripEmbalaje) : '-',
            style: 'textoTablaChico',
            alignment: 'right'
          },
          {
            text: mercancia.PesoEnKg,
            style: 'textoTablaChico',
            alignment: 'right'
          },
          {
            text: mercancia.FraccionArancelaria,
            style: 'textoTablaChico',
            alignment: 'right'
          },
          {
            text: mercancia.PermisoImportacion ? mercancia.PermisoImportacion : '-',
            style: 'textoTablaChico',
            alignment: 'right'
          }
        ],
      )

      if (mercancia.GuiasIdentificacion) {
        for (const guiaIdent of mercancia.GuiasIdentificacion) {
          mercancia.push(
            [
              { text: 'No. de Guia', style: 'tituloTabla', colSpan: 2 },
              {},
              { text: guiaIdent.NumeroGuiaIdentificacion, style: 'textoTablaChico', alignment: 'right' },
              { text: 'Descripción Guía', style: 'tituloTabla' },
              { text: guiaIdent.DescripGuiaIdentificacion, style: 'textoTablaChico', alignment: 'right', colSpan: 2 },
              {},
              { text: 'Peso Guía', style: 'tituloTabla' },
              { text: guiaIdent.PesoGuiaIdentificacion, style: 'textoTablaChico', alignment: 'right' }
            ]
          )
        }
      }

      for (const agregarFinalMercancia of agregarFinalMercancias) {
        mercancias.push(agregarFinalMercancia)
      }

    }


  }

  let remolques = []

  if (cartaPorte?.Mercancias?.Autotransporte?.Remolques) {

    let dataRemolques = cartaPorte?.Mercancias?.Autotransporte?.Remolques.map(valueR => [
      {
        text: valueR.SubTipoRem + ' - ' + valueR.DescripcionSubtipo,
        style: 'textoTablaChico',
        alignment: 'center'
      },
      {
        text: valueR.Placa,
        style: 'textoTablaChico',
        alignment: 'center'
      },
    ])



    remolques.push(
      { text: 'Remolques', style: 'tableHeader' },
      {
        style: 'tableExample',
        table: {
          widths: ['50%', '50%'],
          layout: { defaultBorder: true },
          body: [
            [
              { text: 'Subtipo Remolque', style: 'tituloTabla' },
              { text: 'Placa', style: 'tituloTabla' },
            ],
            ...dataRemolques,
          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
    )
  }


  let agregarCartaPorte = []

  if (cartaPorte) {
    let qrCartaPorte = '';
    if (Array.isArray(cartaPorte?.Ubicaciones) && dataSat?.Fecha && cartaPorte["IdCCP"]) {
      const origen = cartaPorte.Ubicaciones.find(ubi => ubi.TipoUbicacion === 'Origen');
      if (origen) {
        const fechaOrig = formatearFechaSAT(origen.FechaHoraSalidaLlegada);
        const fechaTimb = formatearFechaSAT(dataSat.Fecha);
        qrCartaPorte =
          `https://verificacfdi.facturaelectronica.sat.gob.mx/verificaccp/default.aspx?IdCCP=${cartaPorte["IdCCP"]}&FechaOrig=${fechaOrig}&FechaTimb=${fechaTimb}`;
      }
    }
    // función de formato
    function formatearFechaSAT(fechaISO) {
      try {
        let fechaStr = '';

        // Si es moment()
        if (fechaISO && typeof fechaISO === 'object' && typeof fechaISO.toISOString === 'function' && fechaISO._isAMomentObject) {
          fechaStr = fechaISO.toISOString();
        }
        // Si es Date
        else if (fechaISO instanceof Date) {
          fechaStr = fechaISO.toISOString();
        }
        // Si ya es string
        else if (typeof fechaISO === 'string') {
          fechaStr = fechaISO;
        }
        // Si no es nada válido → vacío
        else {
          return '';
        }

        // Aplicar formato
        return fechaStr.replace('Z', '').split('.')[0];

      } catch {
        return '';
      }
    }
    agregarCartaPorte.push(
      { text: 'Detalle Complemento Carta Porte', style: 'tableHeader' },
      {
        style: "tablaSinMargen",
        table: {
          widths: ["20%", "80%"],
          layout: {
            defaultBorder: true,
          },
          body: [
            [
              (qrCartaPorte ? { qr: qrCartaPorte, alignment: "left", fit: 98 } : { text: 'No se pudo realizar el código QR' }),
              {
                style: 'tableExample',
                table: {
                  widths: ['35%', '35%', '30%'],
                  layout: { defaultBorder: true },
                  body: [
                    [
                      { text: 'Folio transaccion (IDCCP)', style: 'tituloTabla' },
                      { text: 'Transporte Internacional', style: 'tituloTabla' },
                      { text: 'Tipo de transporte', style: 'tituloTabla' },
                    ],
                    [
                      {
                        style: 'textoTablaChico',
                        text: cartaPorte["IdCCP"],
                        alignment: 'center'
                      },
                      {
                        style: 'textoTablaChico',
                        text: cartaPorte["TranspInternac"],
                        alignment: 'center'
                      },
                      {
                        text: '-',
                        style: 'textoTablaChico',
                        alignment: 'center'
                      },
                    ],
                    [
                      { text: 'Via de Transporte', style: 'tituloTabla' },
                      { text: 'País de Orígen o Destino', style: 'tituloTabla' },
                      { text: 'Total distancia recorrida', style: 'tituloTabla' },
                    ],
                    [
                      { text: '-', style: 'textoTablaChico', alignment: 'center' },
                      { text: 'MXN', style: 'textoTablaChico', alignment: 'center' },
                      {
                        text: cartaPorte["TotalDistRec"],
                        style: 'textoTablaChico',
                        alignment: 'right'
                      },
                    ]
                  ]
                },
                layout: {
                  fillColor: (rowIndex, node, columnIndex) => {
                    return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
                  },
                  hLineWidth: function (i, node) {
                    return i === 0 || i === node.table.body.length ? 1 : 1;
                  },
                  vLineWidth: function (i, node) {
                    return i === 0 || i === node.table.widths.length ? 1 : 1;
                  },
                  hLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  vLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  hLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.body.length) {
                      return null;
                    }
                    return { dash: { length: 2, space: 1 } };
                  },
                  vLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.widths.length) {
                      return null;
                    }
                    return { dash: { length: 2 } };
                  },
                }
              },
            ],
          ],
        },
        layout: "noBorders",
      },
      { text: 'Detalle de Transporte', style: 'tableHeader' },
      {
        style: 'tableExample',
        table: {
          widths: ['30%', '10%', '40%', '10%', '10%'],
          layout: { defaultBorder: true },
          body: [
            [
              { text: 'Permiso SCT', style: 'tituloTabla' },
              { text: 'No. de permiso SCT', style: 'tituloTabla' },
              { text: 'Configuración Vehicular / Tipo de remolque', style: 'tituloTabla' },
              { text: 'Placa', style: 'tituloTabla' },
              { text: 'Año', style: 'tituloTabla' },
            ],
            [
              {
                style: 'textoTablaChico',
                text: cartaPorte.Mercancias.Autotransporte.tipoPermiso.Clave + ' - ' + cartaPorte.Mercancias.Autotransporte.tipoPermiso.Descripcion,
                alignment: 'center'
              },
              {
                text: cartaPorte.Mercancias.Autotransporte.NumPermisoSCT,
                style: 'textoTablaChico',
                alignment: 'center'
              },
              { text: cartaPorte.Mercancias.Autotransporte.configVehicular.Clave + ' - ' + cartaPorte.Mercancias.Autotransporte.configVehicular.Descripcion, style: 'textoTablaChico', alignment: 'center' },
              { text: cartaPorte.Mercancias.Autotransporte.IdentificacionVehicular.PlacaVM, style: 'textoTablaChico', alignment: 'center' },
              {
                text: cartaPorte.Mercancias.Autotransporte.IdentificacionVehicular.AnioModeloVM,
                style: 'textoTablaChico',
                alignment: 'center'
              },
            ]
          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
      {
        style: 'tableExample',
        table: {
          widths: ['15%', '15%', '15%', '15%', '15%', '15%', '10%'],
          layout: { defaultBorder: true },
          body: [
            [
              { text: 'Seguro de Responsabilidad Civil', colSpan: 2, style: 'tituloTabla' },
              {},
              { text: 'Seguro de Medio Ambiente', colSpan: 2, style: 'tituloTabla' },
              {},
              { text: 'Seguro de Carga', colSpan: 2, style: 'tituloTabla' },
              {},
              { text: 'Prima Seguro', rowSpan: 2, style: 'tituloTabla' },
            ],
            [
              { text: 'Aseguradora', style: 'tituloTabla' },
              { text: 'Póliza', style: 'tituloTabla' },
              { text: 'Aseguradora', style: 'tituloTabla' },
              { text: 'Póliza', style: 'tituloTabla' },
              { text: 'Aseguradora', style: 'tituloTabla' },
              { text: 'Póliza', style: 'tituloTabla' },
              {},
            ],
            [
              {
                style: 'textoTablaChico',
                text: cartaPorte.Mercancias.Autotransporte.Seguros.AseguraRespCivil,
                alignment: 'center'
              },
              {
                style: 'textoTablaChico',
                text: cartaPorte.Mercancias.Autotransporte.Seguros.PolizaRespCivil,
                alignment: 'center'
              },
              {
                style: 'textoTablaChico',
                text: cartaPorte.Mercancias.Autotransporte.Seguros.AseguraMedAmbiente,
                alignment: 'center'
              },
              {
                text: cartaPorte.Mercancias.Autotransporte.Seguros.PolizaMedAmbiente,
                style: 'textoTablaChico',
                alignment: 'center'
              },
              { text: cartaPorte.Mercancias.Autotransporte.Seguros.AseguraCarga, style: 'textoTablaChico', alignment: 'center' },
              { text: cartaPorte.Mercancias.Autotransporte.Seguros.PolizaCarga, style: 'textoTablaChico', alignment: 'center' },
              {
                text: cartaPorte.Mercancias.Autotransporte.Seguros.PrimaSeguro,
                style: 'textoTablaChico',
                alignment: 'center'
              },
            ]
          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
      ...remolques,
      { text: 'Ubicaciones', style: 'tableHeader' },
      {
        style: 'tableExample',
        table: {
          widths: ['10%', '10%', '30%', '15%', '15%', '20%'],
          layout: { defaultBorder: true },
          body: [
            [
              { text: 'Descripción', style: 'tituloTabla' },
              { text: 'RFC', style: 'tituloTabla' },
              { text: 'Nombre', style: 'tituloTabla' },
              { text: 'Residencia Fiscal', style: 'tituloTabla' },
              { text: 'Identidad Tributaria', style: 'tituloTabla' },
              { text: 'Fecha de Salida / LLegada', style: 'tituloTabla' },
            ],
            ...ubicaciones
          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
      { text: 'Figuras de Transporte', style: 'tableHeader' },
      {
        style: 'tableExample',
        table: {
          widths: ['10%', '10%', '30%', '15%', '15%', '20%'],
          layout: { defaultBorder: true },
          body: [
            [
              { text: 'Descripción', style: 'tituloTabla' },
              { text: 'RFC', style: 'tituloTabla' },
              { text: 'Nombre', style: 'tituloTabla' },
              { text: 'Licencia', style: 'tituloTabla' },
              { text: 'Residencia Fiscal', style: 'tituloTabla' },
              { text: 'Identidad Tributaria', style: 'tituloTabla' },

            ],
            ...figuras,

          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
      { text: 'Detalle Mercancias', style: 'tableHeader' },
      {
        style: 'tableExample',
        table: {
          widths: ['7%', '8%', '30%', '10%', '10%', '10%', '10%', '15%'],
          layout: { defaultBorder: true },
          body: [
            [
              { text: 'Cantidad', style: 'tituloTabla' },
              { text: 'Unidad', style: 'tituloTabla' },
              { text: 'Clave / Descripcion', style: 'tituloTabla' },
              { text: 'Tipo Material peligroso', style: 'tituloTabla' },
              { text: 'Embalaje', style: 'tituloTabla' },
              { text: 'Peso en Kg', style: 'tituloTabla' },
              { text: 'Fraccion Arancelaria', style: 'tituloTabla' },
              { text: 'Pedimento', style: 'tituloTabla' }
            ],
            ...mercancias
          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
    )
  }

  if (complementoComercioExterior) {
    agregarCartaPorte.push(
      // =========================
      // Complemento Comercio Exterior
      // =========================

      {
        text: 'Detalle Complemento Comercio Exterior',
        style: 'tableHeader'
      },
      {
        style: 'tableExample',
        table: {
          widths: ['20%', '20%', '20%', '20%', '20%'],
          body: [
            [
              { text: 'Versión', style: 'tituloTabla' },
              { text: 'Certificado de origen', style: 'tituloTabla' },
              { text: 'Clave de pedimento', style: 'tituloTabla' },
              { text: 'Incoterm', style: 'tituloTabla' },
              { text: 'Tipo de cambio USD', style: 'tituloTabla' },
            ],
            [
              {
                text: complementoComercioExterior?.Version || '-',
                style: 'textoTablaChico',
                alignment: 'center',
              },
              {
                text: complementoComercioExterior?.CertificadoOrigen || '-',
                style: 'textoTablaChico',
                alignment: 'center',
              },
              {
                text: complementoComercioExterior?.ClaveDePedimento || '-',
                style: 'textoTablaChico',
                alignment: 'center',
              },
              {
                text: complementoComercioExterior?.Incoterm || '-',
                style: 'textoTablaChico',
                alignment: 'center',
              },
              {
                text: complementoComercioExterior?.TipoCambioUSD || '-',
                style: 'textoTablaChico',
                alignment: 'center',
              },
            ],
            [
              { text: 'Total USD', style: 'tituloTabla' },
              { text: '', style: 'tituloTabla', colSpan: 4 }, {}, {}, {},
            ],
            [
              {
                text: complementoComercioExterior?.TotalUSD || '-',
                style: 'textoTablaChico',
                alignment: 'center',
              },
              { text: '', colSpan: 4 }, {}, {}, {},
            ],
          ],
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return 1;
          },
          vLineWidth: function (i, node) {
            return 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        },
      },

      // =========================
      // Domicilios emisor / receptor
      // =========================

      {
        text: 'Domicilios Emisor y Receptor',
        style: 'tableHeader',
      },
      {
        style: 'tableExample',
        table: {
          widths: ['50%', '50%'],
          body: [
            [
              { text: 'Domicilio del emisor', style: 'tituloTabla' },
              { text: 'Domicilio del receptor', style: 'tituloTabla' },
            ],
            [
              {
                style: 'textoTablaChico',
                stack: [
                  complementoComercioExterior?.Emisor?.Domicilio?.Calle || '',
                  `CP: ${complementoComercioExterior?.Emisor?.Domicilio?.CodigoPostal || ''}  Col: ${complementoComercioExterior?.Emisor?.Domicilio?.Colonia || ''}`,
                  `Mun: ${complementoComercioExterior?.Emisor?.Domicilio?.Municipio || ''}  Loc: ${complementoComercioExterior?.Emisor?.Domicilio?.Localidad || ''}`,
                  `Estado: ${complementoComercioExterior?.Emisor?.Domicilio?.Estado || ''}  País: ${complementoComercioExterior?.Emisor?.Domicilio?.Pais || ''}`,
                ],
              },
              {
                style: 'textoTablaChico',
                stack: [
                  complementoComercioExterior?.Receptor?.Domicilio?.Calle || '',
                  `CP: ${complementoComercioExterior?.Receptor?.Domicilio?.CodigoPostal || ''}  Col: ${complementoComercioExterior?.Receptor?.Domicilio?.Colonia || ''}`,
                  `Mun: ${complementoComercioExterior?.Receptor?.Domicilio?.Municipio || ''}  Loc: ${complementoComercioExterior?.Receptor?.Domicilio?.Localidad || ''}`,
                  `Estado: ${complementoComercioExterior?.Receptor?.Domicilio?.Estado || ''}  País: ${complementoComercioExterior?.Receptor?.Domicilio?.Pais || ''}`,
                ],
              },
            ],
          ],
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return 1;
          },
          vLineWidth: function (i, node) {
            return 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        },
      },

      // =========================
      // Detalle de mercancías
      // =========================

      {
        text: 'Detalle de Mercancías',
        style: 'tableHeader',
      },
      {
        style: 'tableExample',
        table: {
          widths: ['18%', '22%', '13%', '12%', '17%', '18%'],
          body: [
            [
              { text: 'No. identificación', style: 'tituloTabla' },
              { text: 'Fracción arancelaria', style: 'tituloTabla' },
              { text: 'Cantidad aduana', style: 'tituloTabla' },
              { text: 'Unidad aduana', style: 'tituloTabla' },
              { text: 'Valor unitario aduana', style: 'tituloTabla' },
              { text: 'Valor dólares', style: 'tituloTabla' },
            ],
            // Filas dinámicas de mercancías
            ...(
              (complementoComercioExterior?.Mercancias || []).map((m) => ([
                {
                  text: m.NoIdentificacion || '-',
                  style: 'textoTablaChico',
                  alignment: 'center',
                },
                {
                  text: m.FraccionArancelaria || '-',
                  style: 'textoTablaChico',
                  alignment: 'center',
                },
                {
                  text: m.CantidadAduana || '-',
                  style: 'textoTablaChico',
                  alignment: 'right',
                },
                {
                  text: m.UnidadAduana || '-',
                  style: 'textoTablaChico',
                  alignment: 'center',
                },
                {
                  text: m.ValorUnitarioAduana || '-',
                  style: 'textoTablaChico',
                  alignment: 'right',
                },
                {
                  text: m.ValorDolares || '-',
                  style: 'textoTablaChico',
                  alignment: 'right',
                },
              ]))
            ),
          ],
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return 1;
          },
          vLineWidth: function (i, node) {
            return 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        },
      },
    )
  }

  const title = dataSat.Receptor.impresionEspecial ?
    [
      { text: "Line Item\nNumbe", style: "tituloTabla" },
      ...(cantidadJuntoPrecioUnitario ? [] : [{ text: "Cantidad\nOrder Qty", style: "tituloTabla" }]),
      { text: "Unidad\nUnit", style: "tituloTabla" },
      { text: "Clave SAT", style: "tituloTabla" },
      { text: "Descripción\nDescription", style: "tituloTabla" },
      ...(cantidadJuntoPrecioUnitario ? [{ text: "Cantidad\nOrder Qty", style: "tituloTabla" }] : []),
      { text: "P/U\nPrice Per Unit", style: "tituloTabla" },
      ...(precioUnitarioConDescuento ? [{ text: "P/U c/Desc.\nNet Price", style: "tituloTabla" }] : []),
      ...(ocultarColumnaIVA ? [] : [{ text: "IVA", style: "tituloTabla" }]),
      { text: "IEPS", style: "tituloTabla" },
      { text: "Importe\nNet Value", style: "tituloTabla" },
    ] : [
      { text: "", style: "tituloTabla" },
      ...(cantidadJuntoPrecioUnitario ? [] : [{ text: "Cant", style: "tituloTabla" }]),
      { text: "Unidad", style: "tituloTabla" },
      ...(mostrarClaveSAT ? [{ text: "Clave SAT", style: "tituloTabla" }] : []),
      ...(mostrarClave ? [{ text: "Clave", style: "tituloTabla" }] : []),
      { text: "Descripción", style: "tituloTabla" },
      ...(cantidadJuntoPrecioUnitario ? [{ text: "Cant", style: "tituloTabla" }] : []),
      { text: "P/U", style: "tituloTabla" },
      ...(precioUnitarioConDescuento ? [{ text: "P/U c/Desc.", style: "tituloTabla" }] : []),
      ...(quitarImpuestosFacturas ? [] : [
        ...(ocultarColumnaIVA ? [] : [{ text: "IVA", style: "tituloTabla" }]),
        ...(empresa.imprimirIEPS ? [{ text: "IEPS", style: "tituloTabla" }] : []),
      ]),
      { text: tituloImporte, style: "tituloTabla" },
    ];

  const widths = dataSat.Receptor.impresionEspecial
    ?
    [
      "6%", //Número de item
      ...(cantidadJuntoPrecioUnitario ? [] : ["8%"]), //Cantidad
      "6%", //Unidad
      "9%", //Clave SAT
      `${34 + (ocultarColumnaIVA ? 7 : 0) - (precioUnitarioConDescuento ? widthPUConDescuento : 0)}%`, //Descripción
      ...(cantidadJuntoPrecioUnitario ? ["8%"] : []), //Cantidad
      "10.5%",  //P/U
      ...(precioUnitarioConDescuento ? [`${widthPUConDescuento}%`] : []), //P/U c/Desc.
      ...(ocultarColumnaIVA ? [] : ["7%"]),  //IVA
      "7%",  //IEPS
      "12.5%" //Importe
    ]
    : quitarImpuestosFacturas
      ? [
        "2%",  //Número de linea
        ...(cantidadJuntoPrecioUnitario ? [] : [`${9 + widthExtraCantidad}%`]), //Cantidad
        `${8 + widthExtraUnidad}%`, //Unidad
        ...(mostrarClaveSAT ? [`${widthClaveSAT}%`] : []),//"9%" Clave SAT
        ...(mostrarClave ? [`${widthClave + widthExtraClave}%`] : []),//"12%" Clave
        //Se reparte el ancho de las columnas de IVA e IEPS que no se muestran
        `${30 + widthExtraDescripcionFinal + widthDevueltoClaves - (precioUnitarioConDescuento ? widthPUConDescuento : 0)}%`,
        ...(cantidadJuntoPrecioUnitario ? [`${9 + widthExtraCantidad}%`] : []), //Cantidad
        "15%",  //P/U
        ...(precioUnitarioConDescuento ? [`${widthPUConDescuento}%`] : []), //P/U c/Desc.
        "15%" //IMPORTE
      ]
      : [
        "2%",  //Número de linea
        ...(cantidadJuntoPrecioUnitario ? [] : [`${6 + widthExtraCantidad}%`]), //Cantidad
        `${6 + widthExtraUnidad}%`, //Unidad
        ...(mostrarClaveSAT ? [`${widthClaveSAT}%`] : []),//"9%" Clave SAT
        ...(mostrarClave ? [`${widthClave + widthExtraClave}%`] : []),//"12%" Clave
        //Si la empresa no tiene IEPS aumentar el ancho de la descripción
        `${26 + widthExtraDescripcionFinal - (precioUnitarioConDescuento ? widthPUConDescuento : 0)}%`,
        ...(cantidadJuntoPrecioUnitario ? [`${6 + widthExtraCantidad}%`] : []), //Cantidad
        "10.5%",  //P/U
        ...(precioUnitarioConDescuento ? [`${widthPUConDescuento}%`] : []), //P/U c/Desc.
        ...(ocultarColumnaIVA ? [] : ["9%"]), //IVA
        ...(empresa.imprimirIEPS ? ["7%"] : []), //IEPS
        "12.5%" //IMPORTE
      ];


  const arraySiHayRetenciones = totalRetFL > 0 ? [
    //[
    //   {
    //     border: [true, false, false, false],
    //     text: "Retenciones:",
    //     style: "subheader",
    //   },
    //   {
    //     border: [false, false, true, false],
    //     text: dineroDisabledMask(
    //       totalRetFL
    //     ),
    //     style: "textoChico",
    //     alignment: "right",
    //   },
    // ],
    [
      {
        border: [true, false, false, true],
        text: "TOTAL PAGO:",
        style: "header",
        fillColor: "#e8e8e8",
      },
      {
        border: [false, false, true, true],
        text: dineroDisabledMask(dataSat.Total),
        style: "header",
        fillColor: "#e8e8e8",
        alignment: "right",
      },
    ]] : []

  const total = dataSat.SubTotal - dataSat.Descuento + totalImpFL

  const totalqr = formatQRTotal(dataSat.Total)
  let cadena8 = dataExtra.selloCFDI
  cadena8 = cadena8.slice(-8)

  const linkqr = `https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx?&id=${dataExtra.uuid}&re=${empresa.rfc}&rr=${dataSat.Receptor.Rfc}&tt=${totalqr}&fe=${cadena8}`

  let anadirPagare = []

  if (values.imprimirPagare && values.textoPagare) {
    if (!values.pagareCorto) {
      anadirPagare.push(
        { text: '', pageBreak: 'after' },
        {
          style: "tableExample",
          table: {
            widths: ["18%", "52%", "30%"],
            layout: {
              defaultBorder: false,
            },
            body: [
              [
                ...HeaderEmpresaCard(empresa, true, true,
                {
                  border: [false, false, false, false],
                  table: {
                    headerRows: 1,
                    widths: ["100%"],

                    body: [
                      [
                        {
                          text: "N° Factura:",
                          style: "subheader",
                          alignment: "center",
                        },
                      ],
                      [
                        {
                          text: (dataSat.Serie ? dataSat.Serie : 'F') + ' - ' + dataSat.Folio,
                          style: "textoChico",
                          alignment: "center",
                        },
                      ],
                      [
                        {
                          text: "Moneda:",
                          style: "subheader",
                          alignment: "center",
                        },
                      ],
                      [
                        {
                          text: dataSat.Moneda,
                          style: "textoChico",
                          alignment: "center",
                        },
                      ],
                      [
                        {
                          text: "Tipo de Cambio:",
                          style: "subheader",
                          alignment: "center",
                        },
                      ],
                      [
                        {
                          text: dineroDisabledMask(dataSat.TipoCambio, decimalesTipoCambioPdf),
                          style: "textoChico",
                          alignment: "center",
                        },
                      ],
                    ],
                  },
                  layout: "noBorders",
                }),
              ],
            ],
          },
        },
        {
          style: "tableExample",
          table: {
            widths: ["50%", "20%", "30%"],
            layout: {
              defaultBorder: true,
            },
            body: [
              [
                {
                  text: "PAGARÉ",
                  style: "tituloPagare",
                  alignment: "left",
                  margin: [20, 0, 0, 0],
                  border: [true, true, false, true]
                },
                {
                  text: "BUENO POR:",
                  style: "tituloPagare",
                  alignment: "right",
                  border: [false, true, false, true]
                },
                {
                  text: dineroDisabledMask(dataSat.Total),
                  style: "tituloPagare",
                  alignment: "center",
                  border: [false, true, true, true]
                },
              ],
            ],
          },
        },
      );
    }
    anadirPagare.push(
      {
        style: "tableExample",
        table: {
          widths: ["100%"],
          layout: {
            defaultBorder: true,
          },
          body: [
            [
              {
                text: values.textoPagare + '\n\n', // Salto de línea antes del espacio para firma
                style: "textoPagare",
                alignment: "justify"
              },
            ],
            [
              {
                text: '_______________________________________', // Espacio de firma con línea
                style: "textoPagareFirma",
                alignment: "right",
                margin: [0, 0, 0, 0] // Puedes ajustar el margen según lo necesites
              }
            ],
            [
              {
                text: 'FIRMA', // Espacio de firma con línea
                style: "textoPagareFirma",
                alignment: "right",
                margin: [0, 0, 55, 0] // Puedes ajustar el margen según lo necesites
              }
            ],
          ],
        },
        layout: "noBorders",
      },
    )
  }

  let vendedorTable = []
  const vendedorVar = (empresa.vendedorVentas && values.vendedor) ? values.vendedor : null

  if (empresa.vendedorVentas && values.vendedor) {
    const vendedor = values.vendedor
    vendedorTable.push(
      [
        {
          colSpan: 2,
          table: {
            widths: ["17.5%", "82.5%"],
            layout: {
              defaultBorder: false,
            },
            body: [
              [
                { text: "Vendedor :", style: "subheader" },
                { text: vendedor.nombre + (vendedor.apellidoPaterno ? (" " + vendedor.apellidoPaterno) : "") + (vendedor.apellidoMaterno ? (" " + vendedor.apellidoMaterno) : ""), style: "textoChico" },
              ],
            ],
          },
          layout: "noBorders",
        },
      ],
    )
  }

  const regimenFiscal = dataSat?.Receptor?.RegimenFiscal?.trim();
  const regimenFiscalSection = regimenFiscal
    ? [[
      { text: "Regimen Fiscal:", style: "subheader" },
      { text: regimenFiscal, style: "textoChico" },
    ]]
    : [];


  const impresionEspecial = dataSat.Receptor.impresionEspecial ? [{
    style: "tableExample",
    table: {
      widths: ["40%", "40%", "20%"],
      layout: {
        defaultBorder: false,
      },

      body: [
        [
          {
            table: {
              widths: ["40%", "30%"],
              layout: {
                defaultBorder: false,
              },
              body: [
                [
                  { text: "Purchase Order #:", style: "subheader" },
                  { text: dataSat?.pedido ? dataSat.pedido : 'N/A', style: "textoChico" },
                ],
                [
                  { text: "Invoice number:", style: "subheader" },
                  { text: (dataSat.Serie ? dataSat.Serie : 'F') + ' - ' + dataSat.Folio, style: "textoChico" },
                ],
              ],
            },
            layout: "noBorders",
          },

          {
            table: {
              widths: ["40%", "60%"],
              layout: {
                defaultBorder: false,
              },
              body: [
                [
                  { text: "Invoice date:", style: "subheader" },
                  {
                    text: moment(dataSat.Fecha).locale("es").format("DD/MM/YYYY"),
                    style: "textoChico",
                  },
                ],
                [
                  { text: "Terms:", style: "subheader" },
                  { text: ((dataSat?.Receptor?.diasCredito && dataSat?.Receptor?.diasCredito > 0) ? (dataSat?.Receptor?.diasCredito + " days") : ("Immediate Payment")), style: "textoChico" },
                ],
              ],
            },
            layout: "noBorders",
          },
          {
            table: {
              widths: ["40%", "60%"],
              layout: {
                defaultBorder: false,
              },
              body: [
                [
                  { text: "Seller:", style: "subheader" },
                  {
                    text: (empresa.nombreComercial ? empresa.nombreComercial : empresa.persona
                      ? empresa.nombre
                      : empresa.nombre +
                      " " +
                      empresa.apellidoPaterno +
                      " " +
                      empresa.apellidoMaterno),
                    style: "textoChico",
                  },
                ],
              ],
            },
            layout: "noBorders",
          },
        ],
      ],
    },
    layout: {
      hLineWidth: function (i, node) {
        return i === 0 || i === node.table.body.length ? 1 : 1;
      },
      vLineWidth: function (i, node) {
        return i === 0 || i === node.table.widths.length ? 1 : 1;
      },
      hLineColor: function (i, node) {
        return "#adaaaa";
      },
      vLineColor: function (i, node) {
        return "#adaaaa";
      },
      hLineStyle: function (i, node) {
        if (i === 0 || i === node.table.body.length) {
          return null;
        }
        return { dash: { length: 2, space: 1 } };
      },
      vLineStyle: function (i, node) {
        if (i === 0 || i === node.table.widths.length) {
          return null;
        }
        return { dash: { length: 2 } };
      },
    },
  },] : [];

  // Función para obtener la descripción del tipo de relación
  const getDescripcionTipoRelacion = (tipo) => {
    switch (tipo) {
      case "01": return "01 - Nota de crédito de los documentos relacionados";
      case "02": return "02 - Nota de débito de los documentos relacionados";
      case "03": return "03 - Devolución de mercancía sobre facturas o traslados previos";
      case "04": return "04 - Sustitución de los CFDI previos";
      case "05": return "05 - Traslados de mercancías facturados previamente";
      case "06": return "06 - Factura generada por los traslados previos";
      case "07": return "07 - CFDI por aplicación de anticipo";
      default: return tipo;
    }
  };

  const filasCfdiRelacionados = [];
  if (values.relacionesCFDI && Array.isArray(values.relacionesCFDI)) {
    values.relacionesCFDI.forEach(relacion => {
      const tipoRelacionTexto = getDescripcionTipoRelacion(relacion.tipoRelacion);
      filasCfdiRelacionados.push([
        { text: tipoRelacionTexto, style: 'textoTablaChico', alignment: 'left' },
        { text: relacion.uuid, style: 'textoTablaChico', alignment: 'right' },
      ]);
    });
  }
  let tablaCfdiRelacionados = [];
  if (filasCfdiRelacionados.length > 0) {
    tablaCfdiRelacionados.push(
      { text: 'CFDI Relacionados', style: 'tableHeader', margin: [0, 5, 0, 2], fontSize: 10, }, // Añadimos un pequeño margen
      {
        style: "tableExample",
        table: {
          widths: ['40%', '60%'],
          body: [
            [
              { text: "Tipo de Relación", style: "tituloTabla" },
              { text: "Folio Fiscal (UUID)", style: "tituloTabla" },
            ],
            ...filasCfdiRelacionados,
          ],
        },
        //layout: 'lightHorizontalLines',
        layout: {
          fillColor: (rowIndex) => {
            // Color de fondo alternado para las filas (opcional, lo puedes quitar si no te gusta)
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: (i, node) => (i === 0 || i === node.table.body.length ? 1 : 1),
          vLineWidth: (i, node) => (i === 0 || i === node.table.widths.length ? 1 : 1),
          hLineColor: () => "#adaaaa",
          vLineColor: () => "#adaaaa",
        },
      }
    );
  }

  let advansLeyenda = []
  if (dataSat?.Receptor?.advansLeyenda) {
    advansLeyenda = [{
      table: {
        widths: ['*'],
        body: [
          [
            {
              border: [true, true, true, true],
              text: dataSat?.Receptor?.advansLeyenda,
              margin: [0, 5, 0, 5],
              style: "textoChico",
            },
          ],
        ],
      },
      layout: {
        defaultBorder: false,
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 1 : 1;
        },
        vLineWidth: function (i, node) {
          return i === 0 || i === node.table.widths.length ? 1 : 1;
        },
        hLineColor: function (i, node) {
          return "#adaaaa";
        },
        vLineColor: function (i, node) {
          return "#adaaaa";
        },
        hLineStyle: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return null;
          }
          return { dash: { length: 2, space: 1 } };
        },
        vLineStyle: function (i, node) {
          if (i === 0 || i === node.table.widths.length) {
            return null;
          }
          return { dash: { length: 2 } };
        },
      },
    }];
  }

  // --- Complemento SAT de Leyendas Fiscales ---
  let leyendasFiscales = []
  const nodoLeyendasFisc = dataSat?.Complemento?.Any?.find(item => item['leyendasFisc:LeyendasFiscales'])
  if (nodoLeyendasFisc) {
    const hijosLeyendas = nodoLeyendasFisc['leyendasFisc:LeyendasFiscales']['leyendasFisc:Leyenda']
    const listaLeyendas = Array.isArray(hijosLeyendas) ? hijosLeyendas : (hijosLeyendas ? [hijosLeyendas] : [])

    // pdfmake truena con un table.body vacio
    if (listaLeyendas.length > 0) {
      leyendasFiscales = [{
        table: {
          widths: ['*'],
          body: [
            [
              {
                border: [true, true, true, false],
                text: "Leyendas Fiscales:",
                margin: [0, 5, 0, 5],
                style: "header",
              },
            ],
            ...listaLeyendas.map((valueLeyenda, indexLeyenda) => ([
              {
                border: [true, false, true, indexLeyenda === listaLeyendas.length - 1],
                margin: [0, 0, 0, 5],
                stack: [
                  valueLeyenda['@disposicionFiscal']
                    ? { text: "Disposición Fiscal: " + valueLeyenda['@disposicionFiscal'], style: "textoChico" }
                    : null,
                  valueLeyenda['@norma']
                    ? { text: "Norma: " + valueLeyenda['@norma'], style: "textoChico" }
                    : null,
                  { text: valueLeyenda['@textoLeyenda'] || "", style: "textoChico" },
                ].filter(Boolean),
              },
            ])),
          ],
        },
        layout: {
          defaultBorder: false,
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        },
      }];
    }
  }


  var dd = {
    ...cancelado,
    content: [
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          layout: {
            defaultBorder: false,
          },
          body: [
            [
              ...HeaderEmpresaCard(empresa, true, true, 
              {
                border: [false, false, false, false],
                table: {
                  headerRows: 1,
                  widths: ["100%"],

                  body: [
                    [
                      {
                        text: "N° Factura: " + (dataSat.Serie ? dataSat.Serie : 'R') + ' - ' + dataSat.Folio,
                        style: "subheader",
                      },
                    ],
                    ...(numeroRemision ? [[
                      {
                        text: "N° Remisión: " + (serieRemision ? serieRemision : 'R') + ' - ' + numeroRemision,
                        style: "subheader",
                      },
                    ]] : []),
                    [
                      {
                        text: "Moneda:" + dataSat.Moneda + " T.C.: " + dineroDisabledMask(dataSat.TipoCambio, decimalesTipoCambioPdf),
                        style: "subheader",
                      },
                    ],
                    [
                      { text: "Lugar de expedicion: " + dataSat.LugarExpedicion, style: "subheader", alignment: "left" },
                    ],
                    ...(mostrarOC ? [[
                      { text: "O.C.: " + (dataSat.pedido ? dataSat.pedido : ""), style: "subheader", alignment: "left" },
                    ]] : []),
                    ...(dataSat.req
                      ? [
                        [
                          {
                            text: "Req: " + dataSat.req,
                            style: "subheader",
                            alignment: "left",
                          },
                        ]
                      ]
                      : []),
                    [
                      {
                        text:
                          "Condiciones de pago: " +
                          (dataSat.condicion === 1
                            ? "Contado"
                            : "Crédito" +
                            " (" +
                            (dataSat?.Receptor?.diasCredito
                              ? dataSat?.Receptor?.diasCredito
                              : "0") +
                            " días)"),
                        style: "subheader",
                        alignment: "left",
                      },
                    ],
                    ...(vendedorVar ?
                      [[
                        { text: "Vendedor: " + vendedorVar.nombre + (vendedorVar.apellidoPaterno ? (" " + vendedorVar.apellidoPaterno) : "") + (vendedorVar.apellidoMaterno ? (" " + vendedorVar.apellidoMaterno) : ""), style: "subheader" },
                      ]]
                      : []),
                    ...(dataSat.Exportacion && dataSat.Exportacion !== "01" ?
                      [[
                        { text: "Exportacion: " + dataSat.Exportacion, style: "subheader" },
                      ]]
                      : [])
                  ],
                },
                layout: "noBorders",
              }),
            ],
          ],
        },
      },
      {
        style: "tableExample",
        table: {
          widths: ["60%", "40%"],
          layout: {
            defaultBorder: false,
          },

          body: [
            [
              {
                table: {
                  widths: ["30%", "70%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                    [
                      { text: "Nombre del cliente :", style: "subheader" },
                      { text: dataSat.Receptor.Nombre, style: "textoChico" },
                    ],
                    [
                      { text: "R.F.C :", style: "subheader" },
                      { text: dataSat.Receptor.Rfc, style: "textoChico" },
                    ],
                    ...(dataSat?.Receptor?.NumRegIdTrib
                      ? [[
                        { text: "ID Tributario :", style: "subheader" },
                        { text: dataSat.Receptor.NumRegIdTrib, style: "textoChico" },
                      ]]
                      : []),
                    ...(dataSat?.Receptor?.codigoProveedor
                      ? [[
                        { text: "Código Proveedor:", style: "subheader" },
                        { text: dataSat.Receptor.codigoProveedor, style: "textoChico" },
                      ]]
                      : []),
                    ...regimenFiscalSection,
                    ...(dataSat?.Receptor?.DireccionExtranjera
                      ? [[
                        { text: "Direccion :", style: "subheader" },
                        { text: dataSat.Receptor.DireccionExtranjera, style: "textoChico" },
                      ]]
                      : []),
                    [
                      { text: "Uso de CFDI:", style: "subheader" },
                      {
                        text:
                          "(" +
                          dataSat.usoDeCFDI.c_UsoCFDI +
                          ") " +
                          dataSat.usoDeCFDI.descripcion,
                        style: "textoChico",
                      },
                    ],
                    [
                      { text: "Forma de pago :", style: "subheader" },
                      {
                        text:
                          "(" +
                          dataSat.formaDePago.c_FormaPago +
                          ") " +
                          dataSat.formaDePago.descripcion, style: "textoChico"
                      },
                    ],
                    [
                      { text: "Metodo de pago :", style: "subheader" },
                      {
                        text:
                          dataSat.MetodoPago === "PUE"
                            ? "PUE - Pago en una sola exhibición"
                            : "PPD - Pago en parcialidades o diferido",
                        style: "textoChico"
                      },
                    ],
                    [
                      { text: "CP:", style: "subheader" },
                      { text: (dataSat?.Receptor?.DomicilioFiscalReceptor ? dataSat.Receptor.DomicilioFiscalReceptor : ''), style: "textoChico" },
                    ],

                  ],
                },
                layout: "noBorders",
              },

              {
                table: {
                  widths: ["40%", "60%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                    ...(empresa?.mostrarProyectoVentas
                      ? [
                        [
                          { text: "Proyecto:", style: "subheader" },
                          {
                            text: proyecto,
                            style: "textoChico",
                          },
                        ],
                      ]
                      : []),
                    [
                      { text: "Fecha:", style: "subheader" },
                      {
                        text: moment(dataSat.Fecha).locale("es").format("LL"),
                        style: "textoChico",
                      },
                    ],
                    [
                      dataSat.condicion === 2 && dataSat.Receptor.diasCredito
                        ? { text: "Dias de credito:", style: "subheader" }
                        : null,
                      dataSat.condicion === 2 && dataSat.Receptor.diasCredito
                        ? { text: dataSat.Receptor.diasCredito, style: "textoChico" }
                        : null,
                    ],
                    ...(direccionEntrega?.clienteNombre
                      ? [[
                        { text: "Cliente entrega:", style: "subheader" },
                        {
                          text: direccionEntrega?.clienteNombre,
                          style: "textoChico",
                        },
                      ]]
                      : []),
                    ...(direccionEntrega?.clienteRfc
                      ? [[
                        { text: "RFC entrega:", style: "subheader" },
                        {
                          text: direccionEntrega?.clienteRfc,
                          style: "textoChico",
                        },
                      ]]
                      : []),
                    ...(referenciaEntrega
                      ? [[
                        { text: "Referencia:", style: "subheader" },
                        { text: referenciaEntrega, style: "textoChico" },
                      ]]
                      : []),
                    ...(direccionEntrega?.destino
                      ? [[
                        { text: "Destino:", style: "subheader" },
                        {
                          text: direccionEntrega?.destino,
                          style: "textoChico",
                        },
                      ]]
                      : []),
                    ...(direccionEntrega?.embarque
                      ? [[
                        { text: "Embarque:", style: "subheader" },
                        {
                          text: direccionEntrega?.embarque,
                          style: "textoChico",
                        },
                      ]]
                      : []),
                    ...(direccionEntregaTexto
                      ? [[
                        { text: "Dirección de Entrega:", style: "subheader" },
                        { text: direccionEntregaTexto, style: "textoChico" },
                      ]]
                      : []),
                    ...(mostrarFechaEntrega && dataSat.fechaEntregaEstimada
                      ? [[
                        { text: "Fecha de entrega estimada:", style: "subheader" },
                        {
                          text: moment(dataSat.fechaEntregaEstimada).locale("es").format("LL"),
                          style: "textoChico",
                        },
                      ]]
                      : []),
                    ...(dataSat?.atencion
                      ? [[
                        { text: "Atención a: ", style: "subheader" },
                        { text: dataSat.atencion, style: "textoChico" }
                      ]]
                      : []
                    )
                  ],
                },
                layout: "noBorders",
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        },
      },
      ...impresionEspecial,
      ...agregarEquipoMedico,

      {
        style: "tableExample",
        table: {
          widths: widths,
          layout: {
            defaultBorder: true,
          },
          body: [
            title,
            ...conceptos,
          ],
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        },
      },
      {
        style: "tablaSinMargen",
        table: {
          widths: ["20%", "50%", "30%"],
          layout: {
            defaultBorder: true,
          },
          body: [
            [
              { qr: linkqr, alignment: "left", fit: 98 },
              {
                table: {
                  widths: ["30%", "70%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                    [
                      {
                        border: [true, true, false, false],
                        text: "Cantidad con letra:",
                        style: "subheader",
                      },
                      {
                        border: [false, true, true, false],
                        text: "**( " + numeroALetra(dataSat.Total, dataSat.Moneda) + " )**",
                        style: "textoChico",
                        fontSize: 7,
                      },
                    ],
                    [
                      {
                        border: [true, false, false, !mostrarBancos],
                        text: "Uso de CFDI:",
                        style: "subheader",
                      },
                      {
                        border: [false, false, true, !mostrarBancos],
                        text:
                          "(" +
                          dataSat.usoDeCFDI.c_UsoCFDI +
                          ") " +
                          dataSat.usoDeCFDI.descripcion,
                        style: "textoChico",
                      },
                    ],
                    ...mostrarBancos ? [
                      ...filasBanco1,
                      ...filasBanco2,
                    ] : [],
                  ],
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return i === 0 || i === node.table.body.length ? 1 : 1;
                  },
                  vLineWidth: function (i, node) {
                    return i === 0 || i === node.table.widths.length ? 1 : 1;
                  },
                  hLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  vLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  hLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.body.length) {
                      return null;
                    }
                    return { dash: { length: 2, space: 1 } };
                  },
                  vLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.widths.length) {
                      return null;
                    }
                    return { dash: { length: 2 } };
                  },
                },
              },
              {
                table: {
                  widths: ["50%", "50%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                    [
                      {
                        border: [true, true, false, false],
                        text: "Subtotal:",
                        style: "subheader",
                      },
                      {
                        border: [false, true, true, false],
                        text: dineroDisabledMask(
                          quitarImpuestosFacturas
                            ? dataSat.SubTotal + totalImpFL + agregarImpDesc
                            : dataSat.SubTotal
                        ),
                        style: "textoChico",
                        alignment: "right",
                      },
                    ],
                    ...((quitarImpuestosFacturas
                        ? dataSat.Descuento + agregarImpDesc
                        : dataSat.Descuento) > 0 ? [
                      [
                        {
                          border: [true, false, false, false],
                          text: "Descuento:",
                          style: "subheader",
                        },
                        {
                          border: [false, false, true, false],
                          text: "- " + dineroDisabledMask(
                            quitarImpuestosFacturas
                              ? dataSat.Descuento + agregarImpDesc
                              : dataSat.Descuento
                          ),
                          style: "textoChico",
                          alignment: "right",
                        },
                      ],
                    ] : []),
                    ...(quitarImpuestosFacturas ? [] : impuestosTotales),
                    [
                      {
                        border: [true, false, false, true],
                        text: "TOTAL:",
                        style: "header",
                        fillColor: "#e8e8e8",
                      },
                      {
                        border: [false, false, true, true],
                        text: dineroDisabledMask(total),
                        style: "header",
                        fillColor: "#e8e8e8",
                        alignment: "right",
                      },
                    ],
                    ...retencionesTotales,
                    ...arraySiHayRetenciones,

                  ],
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return i === 0 || i === node.table.body.length ? 1 : 1;
                  },
                  vLineWidth: function (i, node) {
                    return i === 0 || i === node.table.widths.length ? 1 : 1;
                  },
                  hLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  vLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  hLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.body.length) {
                      return null;
                    }
                    return { dash: { length: 2, space: 1 } };
                  },
                  vLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.widths.length) {
                      return null;
                    }
                    return { dash: { length: 2 } };
                  },
                },
              },
            ],
          ],
        },
        layout: "noBorders",
      },
      observaciones,
      ...advansLeyenda,
      ...leyendasFiscales,
      ...agregarCartaPorte,
      ...tablaCfdiRelacionados,
      ...anadirPagare,
      {
        table: {
          widths: ["15%", "30%", "23%", "32%"],
          layout: {
            defaultBorder: false,
          },
          body: [
            [
              {
                colSpan: 4,
                text: '"Este documento es una representacion impresa de un CFDI"',
                style: "header",
                alignment: "center",
              },
              {},
              {},
              {},
            ],
            [
              { text: "Folio Fiscal: ", style: "subheader" },
              { text: dataExtra.uuid, style: "textoDatoFiscal" },
              { text: "Fecha y Hora de Certificación: ", style: "subheader" },
              {
                text: dataExtra?.fechaTimbrado || dataSat?.Fecha || "-",
                style: "textoDatoFiscal",
              },
            ],
            [
              { colSpan: 4, text: "Sello digital CFDI: ", style: "subheader" },
              {},
              {},
              {},
            ],
            [
              {
                colSpan: 4,
                text: dataExtra.selloCFDI,
                style: "textoChicoData",
              },
              {},
              {},
              {},
            ],
            [
              {
                colSpan: 2,
                text: "Numero de serie del Certificado de Sello digital: ",
                style: "subheader",
              },
              {},
              {
                colSpan: 2,
                text: "Numero de serie del Certificado de Sello digital del SAT: ",
                style: "subheader",
              },
              {},
            ],
            [
              {
                colSpan: 2,
                text: dataExtra.noCertificadoCFDI,
                style: "textoChicoData",
              },
              {},
              {
                colSpan: 2,
                text: dataExtra.noCertificadoSAT,
                   style: "textoChicoData",
              },
              {},
            ],
            [
              {
                colSpan: 4,
                text: "Cadena Original del complemento de certificación Digital SAT: ",
                style: "subheader",
              },
              {},
              {},
              {},
            ],
            [
              {
                colSpan: 4,
                text: dataExtra.cadenaOriginalSAT,
                style: "textoChicoData",
              },
              {},
              {},
              {},
            ],
            [
              {
                colSpan: 4,
                text: "Sello Digital del SAT: ",
                style: "subheader",
              },
              {},
              {},
              {},
            ],
            [
              {
                colSpan: 4,
                text: dataExtra.selloSAT,
                style: "textoChicoData",
              },
              {},
              {},
              {},
            ],
            [
              {
                colSpan: 4,
                text: "Sello Digital del CFDI: ",
                style: "subheader",
              },
              {},
              {},
              {},
            ],
            [
              {
                colSpan: 4,
                text: dataExtra.selloCFDI,
                style: "textoChicoData",
              },
              {},
              {},
              {},
            ],
          ],
        },
        layout: "noBorders",
      },
      {
        stack: [
          ...(idKiosko
            ? [
              {
                qr: `https://biwo.online/kiosko?kiosko_id=${idKiosko}`,
                fit: 90,
                alignment: "center",
                eccLevel: "Q",
                margin: [0, 10, 0, 3],
              },
              {
                text: idKiosko ? `Link: https://biwo.online/kiosko?kiosko_id=${idKiosko}` : "",
                style: "text",
                alignment: "center",
                fontSize: 5,
              },
              {
                text: idKiosko ? `Folio: ${idKiosko}` : "",
                style: "text",
                alignment: "center",
                fontSize: 5,
              },
              {
                text: idKiosko ? "Escane para ver su factura." : "",
                style: "text",
                alignment: "center",
                fontSize: 6,
              },
            ]
            : []),
        ],
      },
      ...(empresa.textoAdicional
        ? [
          {
            style: "tableExample",
            table: {
              widths: ["100%"],
              body: [
                [
                  {
                    text: "",
                    style: "header",
                    border: [true, true, true, false],
                    margin: [0, 10, 0, 5],
                  },
                ],
                [
                  {
                    text: empresa.textoAdicional,
                    style: "textoAdicional",
                    border: [true, false, true, true],
                    margin: [0, 0, 0, 5],
                  },
                ],
              ],
            },
            layout: {
              defaultBorder: false,
              hLineWidth: function (i, node) {
                return i === 0 || i === node.table.body.length ? 1 : 1;
              },
              vLineWidth: function (i, node) {
                return i === 0 || i === node.table.widths.length ? 1 : 1;
              },
              hLineColor: function (i, node) {
                return "#adaaaa";
              },
              vLineColor: function (i, node) {
                return "#adaaaa";
              },
              hLineStyle: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                  return null;
                }
                return { dash: { length: 2, space: 1 } };
              },
              vLineStyle: function (i, node) {
                if (i === 0 || i === node.table.widths.length) {
                  return null;
                }
                return { dash: { length: 2 } };
              },
            },
          },
        ]
        : []),
      ...(empresa?.camposFirmaVentas
        ? [BloqueFirmasPdf([{ titulo: "Entregó" }, { titulo: "Recibió" }])]
        : []),
    ],
    footer: (currentPage, pageCount) => ({
      text: `Página ${currentPage} de ${pageCount}`,
      alignment: "right",
      fontSize: 8,
      color: "#888",
      margin: [0, 0, 30, 0],
    }),
    images: {
      logo: empresa.logo.base64Completa,
    },
    styles: {
      header: {
        fontSize: 9,
        bold: true,
      },
      subheader: {
        fontSize: 8,
        bold: true,
      },
      tableExample: {
        margin: [0, 5, 0, 5],
      },
      tablaSinMargen: {
        margin: [0, 0, 0, 0],
      },
      tableHeader: {
        bold: true,
        fontSize: 12,
        color: "black",
        alignment: "center",
      },
      textoChico: {
        fontSize: 8,
      },
      textoAdicional: {
        fontSize: empresa.tamañoTextoAdicional || 8,
      },
      textoChicoFirma: {
        bold: true,
        fontSize: 8,
      },
      textoChicoData: {
        fontSize: 5,
      },
      textoDatoFiscal: {
        fontSize: 8,
      },
      tituloTabla: {
        fontSize: 8,
        bold: true,
        fillColor: "#cccccc",
        style: "subheader",
        alignment: "center",
        border: true,
      },
      tituloPagare: {
        fontSize: 14,
        bold: true,
        fillColor: "#cccccc",
        style: "subheader",
        alignment: "center",
        border: true,
      },
      textoPagare: {
        fontSize: empresa.tamañoTextoPagare || 8,
      },
      textoPagareFirma: {
        bold: true,
        fontSize: empresa.tamañoTextoPagare || 8,
      },
      textoTabla: {
        fontSize: 8,
        italics: false,
      },
      textoTablaChico: {
        fontSize: 6,
        italics: false,
      },
      descuentoPartida: {
        fontSize: 5,
        color: "#777",
      }
    },
    pageSize: "LETTER",
  };
  return dd;
};

// Punto de entrada: solo decide la plantilla según la configuración de la empresa.
const facturaPdf = (values) => {
  const empresa = values.respuestaFactura.empresa;
  if (empresa.tipoPDF === "moderno") return facturaPdfV2(values);
  return facturaPdfClasico(values);
};

export default facturaPdf;
